export const pageTitle = title => {
  return (document.title =
    title + ' -  Precision Ortho CAD');
};
